<template>
  <div class="container_box details_box_styles">
    <!--返回按钮-->
    <div class="go_back" @click="goBackBtn">
      <Icon class="back_icon" type="ios-arrow-back"/>
      <span class="back_txt">{{ $t('key1002627') }}</span>
    </div>
    <!--提交、取消按钮-->
    <div class="fixed_options_box">
      <Button class="mr15" @click="goBackBtn">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="preservation">{{ $t('key1000367') }}</Button>
    </div>
    <!--尺码表模板名称-->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1003487') }}</h2>
        </template>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol" class="basic_item">
            <div class="line_title required">{{ $t('key1001207') }}</div>
            <Input v-model.trim="pageParams.name" clearable style="width: 250px;" :placeholder="$t('key1000781')"></Input>
          </Col>
        </Row>
      </Card>
    </div>
    <!--部位-->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <template #title><h2 class="title_box">{{ $t('key1003290') }}</h2></template>
        <Form class="table_box" ref="tableForm" :model="tableForm" @submit.native.prevent>
          <Table :loading="tableLoading" border max-height="350" :columns="tableColumns" :data="tableForm.tableData">
            <template #cnName="{index}">
              <FormItem :prop="`tableData.${index}.cnName`" :rules="{trigger: 'blur', required:true, message: $t('key1003486')}">
                <Input v-model.trim="tableForm.tableData[index].cnName"></Input>
              </FormItem>
            </template>
          </Table>
        </Form>
        <Button type="dashed" size="large" icon="md-add" class="add_place_styles" @click="addParts">{{ $t('key1003488') }}</Button>
      </Card>
    </div>
    <!--单位-->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <template #title><h2 class="title_box">{{ $t('key1003291') }}</h2></template>
        <Button type="primary" @click="addUnits" style="margin-bottom: 20px;" :disabled="pageParams.productSizeUnitBos.length === 2">{{ $t('key1003489') }}</Button>
        <Row class-name="add_options_box" :gutter="gutterItem">
          <Col :span="6" class="basic_item" v-for="(item, index) in pageParams.productSizeUnitBos" :key="index">
            <div class="line_title">{{ $t('key1003291') + Number(index + 1) + '：' }}</div>
            <Select v-model="item.name" style="width: 150px;" filterable>
              <Option v-for="item in options" :value="item.name" :key="item.name">{{ item.name }}</Option>
            </Select>
            <Radio v-model="item.isDefault" :true-value=1 :false-value=0 @on-change="changeRadio($event, index)"
              style="margin: 0 0 0 15px; position: relative; top: 2px;">{{ $t('key1002571') }}
            </Radio>
            <Icon type="md-remove-circle" class="option_icon_style" style="color: #808695;"
              v-if="pageParams.productSizeUnitBos.length>1" @click="removeUnits(index)"/>
          </Col>
        </Row>
      </Card>
    </div>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {handerDataSorting} from "@/utils/common";

export default {
  name: 'updateSizeTemplate',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      options: [
        {name: 'cm'},
        {name: 'in'}
      ],
      pageParams: {
        name: '', // 模板名称
        productSizePartsBos: [],  // 部位
        productSizeUnitBos: [ // 单位
          {
            name: '',
            isDefault: 1
          }
        ]
      },
      tableColumns: [],
      tableForm: {
        tableData: [
          {
            sortNo: 1,
            place: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003476'),
            cnName: '',
            deName: '',
            enName: '',
            esName: '',
            frName: '',
            itName: '',
            nlName: '',
            plName: '',
            ptName: '',
            roName: ''
          }
        ]
      },
      multilingualPartsKeyList: [
        {key: 'enName', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003477')},
        {key: 'frName', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000434')},
        {key: 'deName', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000435')},
        {key: 'esName', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000436')},
        {key: 'nlName', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003478')},
        {key: 'plName', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000438')},
        {key: 'ptName', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000439')},
        {key: 'itName', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000440')},
        {key: 'roName', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000441')},
      ]
    };
  },
  created() {
    this.getTemplateData();
  },
  methods: {
    // 返回列表
    goBackBtn() {
      this.$router.push('/sizeTemplateManage');
    },
    // 获取模板的信息
    getTemplateData() {
      let v = this;
      v.handleColumns();
      let type = v.$route.query.type;
      if (type === 'edit') {
        v.axios.get(api.get_ymsProductSizeTemplate + `${v.$route.query.ymsProductSizeTemplateId}`, {loading: true}).then(response => {
          if (response.data.code === 0) {
            v.pageParams = response.data.datas;
            let keyList = ['deName', 'enName', 'esName', 'frName', 'itName', 'nlName', 'plName', 'ptName', 'roName'];
            if (v.pageParams.productSizePartsBos) {
              v.pageParams.productSizePartsBos.map((ele) => {
                ele.place = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003290') + ele.sortNo;
                ele.currentIndex = null;
                ele.keyNameList = [];
                keyList.map((item) => {
                  ele[item] = ele[item] === null ? '' : ele[item];
                });
              });
            }
            v.$nextTick(() => {
              v.tableForm.tableData = v.pageParams.productSizePartsBos || [];
              v.tableForm.tableData = v.tableForm.tableData.sort(handerDataSorting('sortNo', 'asc'));
              v.handlerOptions();
            });
          }
        });
      }
    },
    // 新增部位
    addParts() {
      let v = this;
      let sortNoList = [];
      v.tableForm.tableData.map((item) => {
        sortNoList.push(item.sortNo);
      });
      let index = Math.max(...sortNoList) + 1;
      v.tableForm.tableData.push({
        sortNo: index,
        place: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003290')}${index}`,
        cnName: '',
        deName: '',
        enName: '',
        esName: '',
        frName: '',
        itName: '',
        nlName: '',
        plName: '',
        ptName: '',
        roName: ''
      });
      v.handlerOptions();
    },
    // 移除部位
    removeParts(index) {
      this.tableForm.tableData.splice(index, 1);
      this.handlerOptions();
    },
    // 新增单位
    addUnits() {
      let v = this;
      if (v.pageParams.productSizeUnitBos.length < 2) {
        v.pageParams.productSizeUnitBos.push({
          name: '',
          isDefault: 0
        });
      }
    },
    // 移除单位
    removeUnits(index) {
      this.pageParams.productSizeUnitBos.splice(index, 1);
      let arr = this.pageParams.productSizeUnitBos.filter(item => {
        return item.isDefault === 1;
      });
      if (arr.length <= 0) {
        this.pageParams.productSizeUnitBos.map((ele, index) => {
          ele.isDefault = 0;
          if (index === 0) {
            ele.isDefault = 1;
          }
        });
      }
    },
    // 设为默认单位
    changeRadio(event, index) {
      this.pageParams.productSizeUnitBos.map((item, ids) => {
        item.isDefault = 0;
        if (ids === index) {
          item.isDefault = 1;
        }
      });
    },
    // 保存
    preservation() {
      let v = this;
      if (v.pageParams.name === '') {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000777'));
        return false;
      }
      let new_arr = {};
      v.pageParams.productSizePartsBos = [];
      if (v.tableForm.tableData.length > 0) {
        let data = v.tableForm.tableData;
        let abnormalList = [];
        for (let i = 0; i < data.length; i++) {
          let item = data[i];
          v.$set(v.tableForm.tableData[i], 'keyNameList', []);
          let {...obj} = item;
          for (let key in obj) {
            v.multilingualPartsKeyList.map((ele) => {
              if (ele.key === key) {
                new_arr[key] = new_arr[key] || [];
                let name = '';
                if (obj[key]) {
                  name = obj[key].replace(/\s/ig, '');
                }
                if (name && name !== '0' && name !== '') {
                  new_arr[key].push(name);
                }
              }
            });
          }
        }
        if (Object.keys(new_arr).length > 0) {
          for (let j = 0; j < v.multilingualPartsKeyList.length; j++) {
            if (new_arr[v.multilingualPartsKeyList[j].key].length !== 0 && new_arr[v.multilingualPartsKeyList[j].key].length < v.tableForm.tableData.length) {
              v.tableForm.tableData.map((item, index) => {
                if (item[v.multilingualPartsKeyList[j].key] === '') {
                  abnormalList.push({
                    currentIndex: index,
                    keyName: v.multilingualPartsKeyList[j].key
                  });
                }
              });
            }
          }
        }
        if (abnormalList.length <= 0) {
          data.map((talg) => {
            let {...obj} = talg;
            v.pageParams.productSizePartsBos.push(obj);
          });
        } else {
          let new_arr = v.handerGrouping(abnormalList, function (item) {
            return [item.currentIndex];
          }, 'currentIndex');
          if (new_arr.length > 0) {
            new_arr.map((talg) => {
              let list = [];
              v.tableForm.tableData.map((ele, index) => {
                if (index === talg.currentIndex) {
                  talg.data.map((item) => {
                    list.push(item.keyName);
                  });
                  if (list.length > 0) {
                    v.$set(v.tableForm.tableData[index], 'currentIndex', talg.currentIndex);
                    v.$set(v.tableForm.tableData[index], 'keyNameList', list);
                    v.$forceUpdate();
                  }
                }
              });
            });
          }
          v.$set(v.tableForm.tableData[0], 'updateTalg', Math.floor(Math.random() * 10));
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003479'));
          return false;
        }
        // 同一列部位中文名称不能重复
        for (let i = 0; i < v.tableForm.tableData.length - 1; i++) {
          for (let j = i + 1; j < v.tableForm.tableData.length; j++) {
            if (v.tableForm.tableData[i].cnName && v.tableForm.tableData[j].cnName) {
              if (v.tableForm.tableData[i].cnName === v.tableForm.tableData[j].cnName) {
                v.$Message.warning(`${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003475')}`);
                return false;
              }
            }
          }
        }
      }

      if (v.pageParams.productSizeUnitBos.length <= 0) {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003480'));
        return false;
      } else {
        let data = v.pageParams.productSizeUnitBos;
        for (let i = 0; i < data.length; i++) {
          if (data[i].name === '' || !data[i].name) {
            v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003480'));
            return false;
          }
        }
      }
      // 处理序号sortNo的问题
      if (v.pageParams.productSizePartsBos.length > 0) {
        v.pageParams.productSizePartsBos.map((item, index) => {
          item.sortNo = index + 1;
        });
      }
      let type = v.$route.query.type;
      v.$refs.tableForm.validate((valid) => {
        if (valid) {
          // 新增模板
          if (type === 'add') {
            v.axios.post(api.post_ymsProductSizeTemplate, v.pageParams, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
              if (response.data.code === 0) {
                v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003481'));
                v.goBackBtn();
              }
            });
          }
          // 编辑模板
          else {
            let ymsProductSizeTemplateId = {
              ymsProductSizeTemplateId: v.$route.query.ymsProductSizeTemplateId
            };
            let obj = Object.assign({}, v.pageParams, ymsProductSizeTemplateId);
            v.axios.put(api.put_ymsProductSizeTemplate, obj, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
              if (response.data.code === 0) {
                v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003482'));
                v.goBackBtn();
              }
            });
          }
        }
      });
    },

    // 部位升序
    ascendingBtn(item, index) {
      let data = this.tableForm.tableData;
      if (index !== 0) {
        data.splice(index - 1, 1, ...data.splice(index, 1, data[index - 1]));
      }
    },
    // 部位降序
    descendingBtn(item, index) {
      let data = this.tableForm.tableData;
      if (index !== data.length - 1) {
        data.splice(index, 1, ...data.splice(index + 1, 1, data[index]));
      }
    },
    // 处理列表字段
    handleColumns() {
      let v = this;
      let columnsList = [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003290'),
          key: 'place',
          align: 'center',
          width: 100,
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000429'),
          key: 'cnName',
          align: 'center',
          slot: 'cnName',
          minWidth: 160,
          renderHeader: (h, params) => {
            return h('div', {
              style: {
                display: 'flex',
                alignItems: 'center'
              }
            }, [
              h('span', {
                class: 'required'
              }, params.column.title),
            ]);
          },
        }
      ];
      v.multilingualPartsKeyList.map((item) => {
        columnsList.push({
          title: item.name,
          key: item.key,
          align: 'center',
          minWidth: 135,
          render: (h, params) => {
            const {keyNameList, currentIndex} = params.row;
            let key = params.column.key;
            const talg = keyNameList && keyNameList.includes(key) && v.tableForm.tableData[currentIndex][key] === '';
            return h('Input', {
              props: {
                value: params.row[key]
              },
              class: talg ? 'input_error_style' : '',
              on: {
                input: (val) => {
                  v.$set(v.tableForm.tableData[params.index], key, val);
                }
              }
            });
          }
        });
      });
      v.tableColumns = columnsList;
    },

    // 处理操作栏
    handlerOptions() {
      let v = this;
      let options = {
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
        key: 'options',
        align: 'center',
        width: 210,
        render(h, params) {
          let currentIndex = params.index;
          let lastLength = v.tableForm.tableData.length - 1;
          return h('optsButtonList', {
            props: {
              operationList: [
                {
                  text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003483'),
                  show: currentIndex !== 0,
                  clickFn: () => {
                    v.ascendingBtn(params.row, params.index);
                  }
                },
                {
                  text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003484'),
                  show: currentIndex !== lastLength,
                  clickFn: () => {
                    v.descendingBtn(params.row, params.index);
                  }
                },
                {
                  text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000105'),
                  show: true,
                  clickFn: () => {
                    v.removeParts(params.index);
                  }
                }
              ]
            },
            on: {
              setWidth(value) {
                if (value) {
                  v.optionBtnWidth.push(value);
                  params.column.width = Math.max(...v.optionBtnWidth);
                  v.$forceUpdate();
                }
              }
            }
          });
        }
      };
      let data = v.tableForm.tableData;
      if (data.length <= 1) {
        v.tableColumns = v.tableColumns.filter((item) => item.key !== 'options');
      } else {
        let talg = v.tableColumns.findIndex(item => item.key === 'options');
        if (talg <= -1) {
          v.tableColumns.push(options);
        }
      }
    },
  },
  watch: {
    'pageParams.productSizeUnitBos': {
      handler(data) {
        if (data) {
          let v = this;
          if (data.length >= 2 && data[0].name) {
            for (let i = 0; i < data.length - 1; i++) {
              for (let j = i + 1; j < data.length; j++) {
                if (data[i].name === data[j].name) {
                  v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003485'));
                  v.$nextTick(() => {
                    data[j].name = '';
                  });
                  return false;
                }
              }
            }
          }
        }
      },
      deep: true
    }
  }
};
</script>
<style lang="less" scoped>
.container_box {
  .basic_information_box {
    .add_options_box {
      display: flex;
      flex-direction: column;
      padding-left: 40px;

      .basic_item {
        margin-top: 15px;

        .arrow-down {
          color: #34C308;
        }

        .arrow-up {
          color: #D9230B;
        }
      }
    }

    .basic_item {
      .line_title {
        min-width: initial;
      }
    }
  }

  .fixed_options_box {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 10;
    background-color: hsla(0, 1%, 87%, 0.9);
    display: flex;
    justify-content: flex-end;
    padding: 6px 20px 6px 0;
    align-items: center;
  }

  .add_place_styles {
    width: 100%;
    margin: 12px 0;
    font-size: 14px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;

    &:focus {
      box-shadow: none !important;
    }

    .ivu-icon {
      font-size: 16px;
      font-weight: bold;
    }

    span {
      margin-left: 0;
    }
  }

  .table_box {
    /deep/ .ivu-form-item {
      margin: 0 !important;
    }

    /deep/ .ivu-form-item-error-tip {
      position: initial;
      top: initial;
      left: initial;
      padding-top: 6px;
      color: #ed4014;
      margin: 2px 0 5px 0;
    }

    /deep/ .input_error_style {
      .ivu-input {
        border: 1px solid #ed4014;
      }
    }
  }
}
</style>
